<div class="p-2">
	<div class="container my-2">
		<div class="row easie-form">
			<div class="col-12 mx-auto mt-3 p-2">
				<h5 class="text-primary mb-3">Basic Information </h5>

				<div class="form-group">
					<h6 class="section-heading" for="title">
						Title <span class="text-danger">*</span>
						<span class="help-wrap" tabindex="0">
							<i class="fas fa-question-circle"></i>
							<span class="custom-tooltip">Enter a descriptive title for this form</span>
						</span>
					</h6>
					<textarea
						type="text"
						id="title"
						class="form-control"
						rows="2"
						[(ngModel)]="pageSpecificFormObject.title"
						required
						[disabled]="!canUpdate()"
						placeholder="Enter a clear and descriptive title..."
					></textarea>
					<div
						class="invalid-feedback"
						*ngIf="pageSpecificFormObject.title && pageSpecificFormObject.title.trim().length < 10"
					>
						Title should be at least 10 characters long for clarity
					</div>
				</div>
			</div>

			<div class="col-12 mx-auto mt-3 p-2">
				<h5 class="text-primary mb-3">Applicable Year Range </h5>

				<div class="alert alert-info mb-3">
					<i class="fa-solid fa-info-circle me-2"></i>
					Select the academic year range to which this information applies
				</div>

				<div class="row">
					<div class="col-5 px-0">
						<div class="form-group">
							<label class="easie-ion-select-label" for="yearFrom">
								From Year <span class="text-danger">*</span>
								<span class="help-wrap" tabindex="0">
									<i class="fas fa-question-circle"></i>
									<span class="custom-tooltip">Select the starting academic year</span>
								</span>
							</label>
							<div class="easie-ion-select-wrapper">
								<ion-select
									[interfaceOptions]="customModalOptionsFromYear"
									interface="modal"
									placeholder="Select from year"
									(ionChange)="yearFromChange($event)"
									[disabled]="!canUpdate()"
									value="{{ pageSpecificFormObject.yearFrom }}"
								>
									@for (fromYearOption of yearFromList; track fromYearOption; let j = $index) {
									<ion-select-option value="{{ fromYearOption }}">{{ fromYearOption }}</ion-select-option>
									}
								</ion-select>
							</div>
						</div>
					</div>

					<div class="col-2 d-flex align-items-center justify-content-center">
						<div class="year-separator">
							<i class="fa-solid fa-arrow-right text-muted"></i>
						</div>
					</div>

					<div class="col-5 px-1">
						<div class="form-group">
							<label class="easie-ion-select-label" for="yearTo">
								To Year
								<span class="help-wrap" tabindex="0">
									<i class="fas fa-question-circle"></i>
									<span class="custom-tooltip">End year is automatically calculated</span>
								</span>
							</label>
							<div class="year-display">
								<div class="year-to-value">
									{{ pageSpecificFormObject.yearTo || '—' }}
								</div>
							</div>
						</div>
					</div>
				</div>

				<div class="alert alert-warning mt-3" *ngIf="yearFromList.length == 0">
					<i class="fa-solid fa-exclamation-triangle me-2"></i>
					<strong>Setup Required:</strong> Connect to your college IQAC Admin for adding college type and year mapping
					in the application.
				</div>
			</div>
		</div>
	</div>
</div>